import {
  IconAngleRight,
  IconMultipleUsersOutline,
  IconRocket,
} from '@iwoca/icons';
import { Card, Link } from '@iwoca/orion';

import { useMediaQuery } from '../../../../hooks/useMediaQuery';

export function ReferBanner() {
  const isMobile = useMediaQuery('(max-width: 624px)');

  if (isMobile) {
    return (
      <Card className="grid grid-cols-[min-content_1fr] gap-s bg-[#EAF1FB]">
        <IconRocket className="fill-core-40" width={21} height={21} />
        <Link href="tel:02037780549" className="text-left text-s">
          Call us to refer a supplier and each get paid &pound;100{' '}
          <IconAngleRight className="fill-primary-40" />
        </Link>
      </Card>
    );
  }

  return (
    <Card className="mb-xl grid grid-cols-1 gap-m px-l py-xl text-m font-reg">
      <IconMultipleUsersOutline
        className="fill-success-drk"
        width={32}
        height={32}
      />
      <p className="m-0 font-bold">Get rewarded for recommending iwocaPay</p>
      <p className="m-0 text-s">
        Recommend iwocaPay to a supplier and you&apos;ll both get a &pound;100
        voucher of your choice once they&apos;re set up.
      </p>
      <div className="flex items-center text-left">
        <Link href="tel:02037780549" className="text-s">
          Call 0203 778 0549
        </Link>
        <IconAngleRight className="fill-primary-40" />
      </div>
    </Card>
  );
}
